import { render, staticRenderFns } from "./ReceiveResultPopup.vue?vue&type=template&id=2bdb9088&scoped=true&"
import script from "./ReceiveResultPopup.vue?vue&type=script&lang=js&"
export * from "./ReceiveResultPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveResultPopup.vue?vue&type=style&index=0&id=2bdb9088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb9088",
  null
  
)

export default component.exports